import { Record, List } from 'immutable'


const Account = Record({
  id: 0,
  account_id: "",
  account_type:"",
  name:"",
  mail:""
});
export default Account;



// WEBPACK FOOTER //
// ./src/vo/Account.js